import { INPUT, DETALIZATION_PAGE_ACTIONS } from './constants';

export function inputText(text) {
  return { type: INPUT, text };
}

export const setDetalizationPageCurrentModal = (payload) => ({
  type: DETALIZATION_PAGE_ACTIONS.SET_CURRENT_DETALIZATION_MODAL,
  payload,
});
